// extracted by mini-css-extract-plugin
export default {"root":"ToggleButton_root__qB4CO","toggleWrapper":"ToggleButton_toggleWrapper__05ayn","activeBtn":"ToggleButton_activeBtn__zERjB"};